export const syscall = self.syscall;
